var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4997 19.8057C6.13301 19.8057 2.58301 16.2557 2.58301 11.8891C2.58301 7.52241 6.13301 3.97241 10.4997 3.97241C14.8663 3.97241 18.4163 7.52241 18.4163 11.8891C18.4163 16.2557 14.8663 19.8057 10.4997 19.8057ZM10.4997 5.22241C6.82467 5.22241 3.83301 8.21408 3.83301 11.8891C3.83301 15.5641 6.82467 18.5557 10.4997 18.5557C14.1747 18.5557 17.1663 15.5641 17.1663 11.8891C17.1663 8.21408 14.1747 5.22241 10.4997 5.22241Z",
    fill: "#070519"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4997 6.26343C9.47011 6.26343 8.46186 6.55685 7.59308 7.10932C6.72429 7.66179 6.03095 8.45042 5.59429 9.38281C5.15764 10.3152 4.99576 11.3527 5.12761 12.3738C5.25947 13.3949 5.6796 14.3573 6.33879 15.1481C6.99797 15.939 7.86891 16.5256 8.84954 16.8393C9.83017 17.1529 10.8799 17.1806 11.8757 16.9191C12.8715 16.6575 13.7721 16.1176 14.472 15.3626C15.172 14.6075 15.6422 13.6686 15.8277 12.6559L10.4997 11.6801V6.26343Z",
    fill: "#D95353"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 3.13843H8C7.65833 3.13843 7.375 2.85509 7.375 2.51343C7.375 2.17176 7.65833 1.88843 8 1.88843H13C13.3417 1.88843 13.625 2.17176 13.625 2.51343C13.625 2.85509 13.3417 3.13843 13 3.13843Z",
    fill: "#070519"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.cf57e540f8c00ff6a20d124d1fba2080.svg";
export { ForwardRef as ReactComponent };